import { PDxPOFileType } from "./PDxPOFileType.enum";
import { PDxTransmissionMethod } from "./PDxTransmissionMethod.enum";
import { PDxUserPermission } from "./PDxUserPermission.enum";
import { PDxPOStatus } from "./PDxPOStatus.enum";

export class PDxListItem<T> {
    value: T;
    text: string;
}

export class PDxCheckListItem<T> extends PDxListItem<T> {
    selected: boolean;
}

export class PDxGroupListItem<T> extends PDxListItem<T> {
    group: string;
}

export abstract class PDxLists {
    public static PDxUserPermissions(): PDxListItem<PDxUserPermission>[] {
        return [
            { value: PDxUserPermission.Purchaser, text: 'Purchaser' },
            { value: PDxUserPermission.ApproverLevel1, text: 'Approver Level 1' },
            { value: PDxUserPermission.ApproverLevel2, text: 'Approver Level 2' },
            { value: PDxUserPermission.ApproverLevel3, text: 'Approver Level 3' },
            { value: PDxUserPermission.ApproverLevel4, text: 'Approver Level 4' },
            { value: PDxUserPermission.ApproverLevel5, text: 'Approver Level 5' },
            { value: PDxUserPermission.Invoicer, text: 'Invoicer' },
            { value: PDxUserPermission.Dashboard, text: 'Dashboard' },
        ];
    };

    public static PDxTransmissionMethods(): PDxListItem<PDxTransmissionMethod>[] {
        return [
            { value: PDxTransmissionMethod.Email, text: 'Email' },
            { value: PDxTransmissionMethod.SFTP, text: 'SFTP' },
            { value: PDxTransmissionMethod.EFax, text: 'eFax' }
        ];
    };

    public static PDxPOFileTypes(): PDxListItem<PDxPOFileType>[] {
        return [
            { value: PDxPOFileType.PDF, text: 'PDF' },
            { value: PDxPOFileType.EDI, text: 'EDI' }
        ];
    };

    public static PDxPOStatuses(): PDxListItem<PDxPOStatus>[] {
        return [
            { value: PDxPOStatus.AwaitingApproval1, text: 'Pending Approval' },
            { value: PDxPOStatus.Transmitted, text: 'Transmitted' },
            { value: PDxPOStatus.Rejected, text: 'Rejected' },
            { value: PDxPOStatus.PartiallyReceived, text: 'Partially Received' },
            { value: PDxPOStatus.FullyReceived, text: 'Fully Received' }
        ];
    };

    public static PDxAdminPOStatuses(): PDxListItem<PDxPOStatus>[] {
        return [
            { value: PDxPOStatus.AwaitingApproval1, text: 'Pending Approval 1' },
            { value: PDxPOStatus.AwaitingApproval2, text: 'Pending Approval 2' },
            { value: PDxPOStatus.AwaitingApproval3, text: 'Pending Approval 3' },
            { value: PDxPOStatus.AwaitingApproval4, text: 'Pending Approval 4' },
            { value: PDxPOStatus.AwaitingApproval5, text: 'Pending Approval 5' },
            { value: PDxPOStatus.Approved, text: 'Pending File Generation' },
            { value: PDxPOStatus.AwaitingEmail, text: 'Pending Transmission' },
            { value: PDxPOStatus.Transmitted, text: 'Transmitted' },
            { value: PDxPOStatus.Rejected, text: 'Rejected' },
        ];
    };

    public static States(): PDxListItem<string>[] {
        return [
            { value: 'AL', text: 'Alabama' },
            { value: 'AK', text: 'Alaska' },
            { value: 'AZ', text: 'Arizona' },
            { value: 'AR', text: 'Arkansas' },
            { value: 'CA', text: 'California' },
            { value: 'CO', text: 'Colorado' },
            { value: 'CT', text: 'Connecticut' },
            { value: 'DE', text: 'Delaware' },
            { value: 'DC', text: 'District Of Columbia' },
            { value: 'FL', text: 'Florida' },
            { value: 'GA', text: 'Georgia' },
            { value: 'HI', text: 'Hawaii' },
            { value: 'ID', text: 'Idaho' },
            { value: 'IL', text: 'Illinois' },
            { value: 'IN', text: 'Indiana' },
            { value: 'IA', text: 'Iowa' },
            { value: 'KS', text: 'Kansas' },
            { value: 'KY', text: 'Kentucky' },
            { value: 'LA', text: 'Louisiana' },
            { value: 'ME', text: 'Maine' },
            { value: 'MD', text: 'Maryland' },
            { value: 'MA', text: 'Massachusetts' },
            { value: 'MI', text: 'Michigan' },
            { value: 'MN', text: 'Minnesota' },
            { value: 'MS', text: 'Mississippi' },
            { value: 'MO', text: 'Missouri' },
            { value: 'MT', text: 'Montana' },
            { value: 'NE', text: 'Nebraska' },
            { value: 'NV', text: 'Nevada' },
            { value: 'NH', text: 'New Hampshire' },
            { value: 'NJ', text: 'New Jersey' },
            { value: 'NM', text: 'New Mexico' },
            { value: 'NY', text: 'New York' },
            { value: 'NC', text: 'North Carolina' },
            { value: 'ND', text: 'North Dakota' },
            { value: 'OH', text: 'Ohio' },
            { value: 'OK', text: 'Oklahoma' },
            { value: 'OR', text: 'Oregon' },
            { value: 'PA', text: 'Pennsylvania' },
            { value: 'RI', text: 'Rhode Island' },
            { value: 'SC', text: 'South Carolina' },
            { value: 'SD', text: 'South Dakota' },
            { value: 'TN', text: 'Tennessee' },
            { value: 'TX', text: 'Texas' },
            { value: 'UT', text: 'Utah' },
            { value: 'VT', text: 'Vermont' },
            { value: 'VA', text: 'Virginia' },
            { value: 'WA', text: 'Washington' },
            { value: 'WV', text: 'West Virginia' },
            { value: 'WI', text: 'Wisconsin' },
            { value: 'WY', text: 'Wyoming' },
        ];
    }

    public static AbbreviatedStates(): PDxListItem<string>[] {
        return [
            { value: 'AL', text: 'AL' },
            { value: 'AK', text: 'AK' },
            { value: 'AR', text: 'AR' },
            { value: 'AZ', text: 'AZ' },
            { value: 'CA', text: 'CA' },
            { value: 'CO', text: 'CO' },
            { value: 'CT', text: 'CT' },
            { value: 'DC', text: 'DC' },
            { value: 'DE', text: 'DE' },
            { value: 'FL', text: 'FL' },
            { value: 'GA', text: 'GA' },
            { value: 'HI', text: 'HI' },
            { value: 'IA', text: 'IA' },
            { value: 'ID', text: 'ID' },
            { value: 'IL', text: 'IL' },
            { value: 'IN', text: 'IN' },
            { value: 'KS', text: 'KS' },
            { value: 'KY', text: 'KY' },
            { value: 'LA', text: 'LA' },
            { value: 'MA', text: 'MA' },
            { value: 'MD', text: 'MD' },
            { value: 'ME', text: 'ME' },
            { value: 'MI', text: 'MI' },
            { value: 'MN', text: 'MN' },
            { value: 'MO', text: 'MO' },
            { value: 'MS', text: 'MS' },
            { value: 'MT', text: 'MT' },
            { value: 'NC', text: 'NC' },
            { value: 'ND', text: 'ND' },
            { value: 'NE', text: 'NE' },
            { value: 'NH', text: 'NH' },
            { value: 'NJ', text: 'NJ' },
            { value: 'NM', text: 'NM' },
            { value: 'NV', text: 'NV' },
            { value: 'NY', text: 'NY' },
            { value: 'OH', text: 'OH' },
            { value: 'OK', text: 'OK' },
            { value: 'OR', text: 'OR' },
            { value: 'PA', text: 'PA' },
            { value: 'RI', text: 'RI' },
            { value: 'SC', text: 'SC' },
            { value: 'SD', text: 'SD' },
            { value: 'TN', text: 'TN' },
            { value: 'TX', text: 'TX' },
            { value: 'UT', text: 'UT' },
            { value: 'VA', text: 'VA' },
            { value: 'VT', text: 'VT' },
            { value: 'WA', text: 'WA' },
            { value: 'WI', text: 'WI' },
            { value: 'WV', text: 'WV' },
            { value: 'WY', text: 'WY' },
        ];
    }
}